export enum BugPriority {
  normal = 'normal',
  medium = 'medium',
  high = 'high',
}
